export default {
  login: "mdial009",
  id: 36002261,
  node_id: "MDQ6VXNlcjM2MDAyMjYx",
  avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/mdial009",
  html_url: "https://github.com/mdial009",
  followers_url: "https://api.github.com/users/mdial009/followers",
  following_url: "https://api.github.com/users/mdial009/following{/other_user}",
  gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
  starred_url: "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
  organizations_url: "https://api.github.com/users/mdial009/orgs",
  repos_url: "https://api.github.com/users/mdial009/repos",
  events_url: "https://api.github.com/users/mdial009/events{/privacy}",
  received_events_url: "https://api.github.com/users/mdial009/received_events",
  type: "User",
  site_admin: false,
  name: "Madany Diallo",
  company: null,
  blog: "mdial009.github.io",
  location: "Bronx NY",
  email: null,
  hireable: true,
  bio: "Seeking Software Engineering Opportunities. ",
  twitter_username: null,
  public_repos: 15,
  public_gists: 0,
  followers: 2,
  following: 3,
  created_at: "2018-01-31T14:22:58Z",
  updated_at: "2020-08-28T07:35:28Z",
};
